import type {AiChatAnimationMetadata} from '@Components/ai-chat-window/ai-chat-window.types';

export enum AnimationCreationStatus {
  IDLE = 'idle',
  CREATING = 'creating',
  COMPLETED = 'completed',
  FAILED = 'failed',
  STOPPED = 'stopped',
}

export interface AiChatAnimation {
  animationHashedId: string;
  animationUrl: string;
  thumbnailUrl: string;
  width: number;
  height: number;
  duration: number;
  hasAudio: boolean;
  model: string;
  startTime?: number;
  endTime?: number;
}

export interface AnimationCreationState {
  isVisible: boolean;
  status: AnimationCreationStatus;
  animations?: AiChatAnimation[];
  errorMessage?: string;
  abortController?: AbortController;
  pollingKey?: string;
}

export const CHAT_MESSAGES_CONTAINER_ID = 'pmw-chat-messages-container';

export const ANIMATION_CREATION_SCROLL_NUDGE_PX = 250;

export const ANIMATION_CREATION_SCROLL_NUDGE_DESKTOP_PX = 400;

export enum VideoSubjectKind {
  GENERATED = 'generated',
  ATTACHMENT = 'attachment',
}

/** A chat-generated image; its id names both the strip's creation state and the asset "create more" animates. */
export interface GeneratedVideoSubject {
  kind: VideoSubjectKind.GENERATED;
  imageHashedId: string;
}

/** A user's attachment. The attachmentKey names the creation state; regenerationImageHashedId is the asset "create more" animates, null for a design so it is not offered. */
export interface AttachmentVideoSubject {
  kind: VideoSubjectKind.ATTACHMENT;
  attachmentKey: string;
  regenerationImageHashedId: string | null;
}

export type VideoSubject = GeneratedVideoSubject | AttachmentVideoSubject;

export interface AssistantMessageImagePartAnimationCreationsProps {
  chatId: string;
  videoSubject: VideoSubject;
  animations?: AiChatAnimationMetadata[];
  imageWidth?: number | null;
  imageHeight?: number | null;
}
